import { KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { DRAG_HOLD_MS, DRAG_SLOP } from './touchRules';
/**
 * The drag-and-drop sensors for every sortable list, table and tree. A mouse drags after moving
 * `mouseDistance` px (default 8; 0 drags at once). A finger drags after holding `DRAG_HOLD_MS`, so scrolling and swiping never start a drag.
 *
 * @example
 * ```tsx
 * const sensors = useDragSensors({ keyboard: { coordinateGetter: sortableKeyboardCoordinates } }); // keyboard is optional
 * <DndContext sensors={sensors} ...>
 * ```
 * @export
 */
const useDragSensors = (options = {}) => {
    const { mouseDistance = 8 } = options;
    const mouse = useSensor(MouseSensor, mouseDistance > 0 ? { activationConstraint: { distance: mouseDistance } } : undefined);
    const touch = useSensor(TouchSensor, { activationConstraint: { delay: DRAG_HOLD_MS, tolerance: DRAG_SLOP } });
    const keyboard = useSensor(KeyboardSensor, options.keyboard);
    // Keyboard dragging only where the list asks for it (useSensors leaves out null)
    return useSensors(mouse, touch, options.keyboard ? keyboard : null);
};
export default useDragSensors;
